import { getJson } from "../libs/request";
// import { mapValues, groupBy, omit }  from 'lodash';
import {
  SET_BLOG_DATA,
  SET_BLOG_DETAIL,
  SET_BLOG_LOADING
} from "../actions/types";

import { CONTENT_SITE_URL } from "../environments";

function setBlogData(data) {
  return {
    type: SET_BLOG_DATA,
    data
  };
}

function setBlogDetail(data) {
  return {
    type: SET_BLOG_DETAIL,
    data
  };
}

function setBlogLoading(loading) {
  return {
    type: SET_BLOG_LOADING,
    loading
  };
}

const INITIAL_STATE = {
  blogLoading: false,
  blogs: [],
  blogDetail: {}
};

export const getBlogs = (
  lang = "TH",
  category = "all",
  limit = "20",
  posts = "moneytable",
  page = "1"
) => async (dispatch, getState) => {
  dispatch(setBlogLoading(true));
  // const url = `//${CONTENT_SITE_URL}/index.php/wp-json/wp/v2/posts?per_page='+limit+'&tags=63&_embed=featuredmedia,category`;

  const langSet = lang === "EN" ? "&tags=21" : "&tags_exclude=21";
  // resolve access-control-allow-origin = callback=?
  // https://stackoverflow.com/questions/6396623/jquery-getjson-access-control-allow-origin-issue
  const url = `//${CONTENT_SITE_URL}/index.php/wp-json/wp/v2/${posts}?per_page=${limit}&page=${page}${langSet}&categories_exclude=30&_embed=featuredmedia,category&callback=?`;

  getJson(url, {})
    .then(response => {
      const { data } = response;

      new Promise((resolve, reject) => {
        let blogsData = [];
        let categories = [];

        data.forEach(blog => {
          const blog_category = blog._embedded["wp:term"][0][0].name;
          // const blog_tag      = blog._embedded['wp:term'][1];

          //clean input for check
          const cat_target = category.toLowerCase().replace(/\s/g, "");
          const cat_source = blog_category.toLowerCase().replace(/\s/g, "");

          // set true or false for en post to display on website
          // ###### Wed Sep 26 11:19:31 WIB 2018
          // const is_en = blog_tag.filter(function(blog_tag) {
          //   return blog_tag.name.toLowerCase() === 'en'; // returns true or false
          // });

          // blog.lang = (is_en.length>0)?'EN':'TH';

          if (cat_target === cat_source) {
            blogsData = [...blogsData, blog];
          } else if (category === "all" || category === "") {
            blogsData = data;
          }

          if (!categories.includes(blog_category)) {
            categories = [...categories, blog_category];
          }
        });

        const TotalPages = response.headers["x-wp-totalpages"];
        const IsPage = page;
        resolve({ blogsData, categories, TotalPages, IsPage });
      }).then(response => {
        const blogsData = response.blogsData;
        const categories = response.categories;
        const TotalPages = response.TotalPages;
        const IsPage = response.IsPage;

        dispatch(setBlogData({ blogsData, categories, TotalPages, IsPage }));
        dispatch(setBlogLoading(false));
      });
    })
    .catch(error => {
      console.log("error: ", error);
      dispatch(setBlogLoading(false));
    });
};

// export const getBlogDetail = slug => {
//   return dispatch => {
//     dispatch(setBlogDetail(slug));
//   }
// };

export const getBlogs_byCat = (lang = 'TH', category, limit = "5") => async (
  dispatch,
  getState
) => {
  dispatch(setBlogLoading(true));

  const langSet = lang === "EN" ? "&tags=21" : "&tags_exclude=21";
  // const url = `//${CONTENT_SITE_URL}/index.php/wp-json/wp/v2/posts?per_page='+limit+'&tags=63&_embed=featuredmedia,category`;
  const url = `//${CONTENT_SITE_URL}/index.php/wp-json/wp/v2/moneytable?per_page=${limit}${langSet}&categories_exclude=30&_embed=featuredmedia,category&callback=?`;

  getJson(url, {})
    .then(response => {
      const { data } = response;

      new Promise((resolve, reject) => {
        let blogsData = data;
        let categories = [];

        data.forEach(blog => {
          const blog_category = blog._embedded["wp:term"][0][0].name;
          // const blog_tag = blog._embedded["wp:term"][1];
          const clean_category = blog_category.toLowerCase().replace(/\s/g, "");
          blog.category_clean_name =
            clean_category === "hrtips" || clean_category === "hranswers"
              ? "hr"
              : clean_category;

          // const is_en = blog_tag.filter(function(blog_tag) {
          //   return blog_tag.name.toLowerCase() === "en"; // returns true or false
          // });

          // blog.lang = is_en.length > 0 ? "EN" : "TH";

          if (!categories.includes(blog_category)) {
            categories = [...categories, blog_category];
          }
        });

        resolve({ blogsData, categories });
      }).then(response => {
        const blogsData = response.blogsData;
        const categories = response.categories;

        dispatch(setBlogData({ blogsData, categories }));
        dispatch(setBlogLoading(false));
      });
    })
    .catch(error => {
      console.log("error: ", error);
      dispatch(setBlogLoading(false));
    });
};

export const getBlogDetail = (posts = "moneytable", slug) => async (
  dispatch,
  getState
) => {
  dispatch(setBlogLoading(true));

  // http://content-management.moneytable.com/index.php/wp-json/wp/v2/moneytable?slug=กลยุทธ์รับมือโลก-disruption-อีกก&_embed=featuredmedia,category&callback=?
  const url = `//${CONTENT_SITE_URL}/index.php/wp-json/wp/v2/${posts}?slug=${decodeURIComponent(slug)}&_embed=featuredmedia,category&callback=?`;

  getJson(url, {})
    .then(response => {
      const { data } = response;
      dispatch(setBlogDetail({ data }));
      dispatch(setBlogLoading(false));
    })
    .catch(error => {
      console.log("error: ", error);
      dispatch(setBlogLoading(false));
    });
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_BLOG_DATA:
      return {
        ...state,
        blogs: {
          data: action.data.blogsData,
          categories: action.data.categories,
          totalpages: action.data.TotalPages,
          ispage: action.data.IsPage
        }
      };

    case SET_BLOG_DETAIL:
      const detail = action.data.data;

      return {
        ...state,
        blogDetail: {
          id: detail[0].id,
          date: detail[0].date,
          title: detail[0].title.rendered,
          content: detail[0].content.rendered,
          author: detail[0]._embedded["author"][0].name
          // featuredmedia: detail[0]._embedded['wp:featuredmedia'][0].source_url?detail[0]._embedded['wp:featuredmedia'][0].source_url:'',
        }
      };
    // const blogs = state.blogs.data;
    // const detail = blogs.filter(item => {

    //   // ###### Mon Jul 16 10:48:56 ICT 2018
    //   // fix thai url encode from json output

    //   return decodeURIComponent(item.slug) === decodeURIComponent(action.slug);
    // });

    // return {
    //   ...state,
    //   blogDetail: {
    //     id: detail[0].id,
    //     date: detail[0].date,
    //     title: detail[0].title.rendered,
    //     content: detail[0].content.rendered,
    //     author: detail[0]._embedded['author'][0].name,
    //     // featuredmedia: detail[0]._embedded['wp:featuredmedia'][0].source_url?detail[0]._embedded['wp:featuredmedia'][0].source_url:'',
    //   },
    // };

    case SET_BLOG_LOADING:
      return {
        ...state,
        blogLoading: action.loading
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/blogReducer.js